<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>

    <!-- Header -->
    <header-component :headerTitle="headerText" />

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-repair" v-model="filterPopup" persistent max-width="1145px" >
        <v-card class="filter_ui">
          <v-card-actions>
            <!-- <v-autocomplete v-model="return_type_search" variant="outlined" :items="return_types" item-title="original_code" item-value="id" label="Return Types" > </v-autocomplete> -->
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="ra_location_search" label="Location"  class="ma-2" variant="outlined"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="ra_branch_search" label="Branch"  class="ma-2" variant="outlined"></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="region_search" label="Region"  class="ma-2" variant="outlined"></v-text-field>
            <!-- <v-autocomplete v-model="region_search" outlined :items="regions" item-title="original_code" item-value="id" label="Region" > </v-autocomplete> -->
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" class="text-none" variant="outlined" color="primary" @click="closeFilterpopup" >Cancel</v-btn >
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="fetchTableData" >Apply Filter(S)</v-btn >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Popups for approval and rejection -->
    <v-row justify="center">
      <v-dialog v-model="approvePopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="approvePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span ><strong>{{ successmessage }}</strong> </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" @click="loadData" class="mb-3">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="rejectPopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn varian="solo" icon @click="rejectPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span>
              <strong>{{ selected.length }}. Sub Request Id successfully Rejected</strong >
            </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" @click="rejectPopup = false" class="mb-3 text-none" >Ok</v-btn >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Download Popup -->
    <v-row justify="center">
      <v-dialog v-model="downloadPopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="downloadPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span><strong>CSV file downloaded successfully !</strong> </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" class="mb-3 text-none">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Image show popup -->
    <v-dialog v-model="dialogVisible" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <span class="headline">Images</span>
          <v-spacer></v-spacer>
          <v-btn icon variant="solo" @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text>
          <v-row>
            <v-col v-for="(imageUrl, index) in item_images" :key="index" cols="4">
              <img :src="imageUrl" width="100%" contain @click="openImagePopupSingle(imageUrl)" class="img-rad-size" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="approvalHistoryPopup" persistent max-width="1100">
      <v-card class="v-card-100">
        <v-card-title class="d-flex align-center">
          <span class="headline">Approval History</span>
          <v-spacer></v-spacer>
          <v-btn variant="solo" icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text>
          <v-data-table
            density="compact"
            :dense="true"
            v-model="approvalHistory"
            :items="history_table_data"
            disable-pagination
            :hide-default-footer="false"
            :headers="Historyheaders"
            :loading="loading"
            fixed-header
            loading-text="Loading Data... Please wait"
            class="elevation-1 overflow-auto"
          >
          <template v-slot:item.created_at="{ item }">
            {{ formatTimestamp(item.created_at) }}
          </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions center>
          <v-spacer></v-spacer>
          <v-btn color="primary"  variant="flat" class="mb-3 text-none" @click="closeDialog">Okay</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="imagePopup" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <v-spacer></v-spacer>
          <v-btn icon @click="imagePopup = false;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-img :src="selectedImage" width="100%" style="border-radius:8px;" contain></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- search -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style mt-6">
      <!-- Search fields -->
      <v-row>
        <v-col cols="3" sm="3" class="pb-0">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData('search_action')" ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <!-- Actions buttons -->
        <v-card-actions style="margin-bottom: 18px;">
          <v-menu offset-y v-if="!(this.currentUser.roles.includes('default_user'))">
            <template v-slot:activator="{ props }">
              <v-btn
                color="primary"
                v-bind="props"
                :disabled="selected.length == 0"
                variant="flat"
                size="x-large"
                class="text-none"
              >
                Approval Decision
                <v-icon dark>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="approveDecision('Approve')">
                <v-list-item-title>Approve</v-list-item-title>
              </v-list-item>
              <v-list-item @click="approveDecision('Reject')">
                <v-list-item-title>Reject</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-btn class="ma-2" :color="disableActionBtns() ? 'secondry' : 'primary'" :disabled="disableActionBtns()" @click="downloadCsv">DOWNLOAD</v-btn>
          <v-btn class="ma-2" color="primary" @click="uploadfile()">UPLOAD</v-btn> -->
        </v-card-actions>
  
  
        <!-- Filter -->
          <!-- <v-expansion-panels class="custom-control_outlined" ref="filterPopupRef" readonly style="max-width: 150px; margin-bottom: 18px; min-height: 52px;" >
            <v-expansion-panel outlined @click="filterListOfButtons">
              <v-expansion-panel-title >Filter
              </v-expansion-panel-title> -->
              <v-expansion-panels class="custom-control_outlined m-0 pt-2" ref = "filterPopupRef" readonly style="max-width: 110px; margin-bottom: 16px; height: 52px;">
                <v-expansion-panel variant="outlined" @click="filterListOfButtons" >
                  <v-expansion-panel-title>Filter
                  </v-expansion-panel-title>
                  </v-expansion-panel>
              </v-expansion-panels>
      </v-row>
      
    </v-card-title>
     <!-- Data Table -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto;" class="p-0">
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          :items="table_data"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :loading="loading"
          fixed-header
          height="100%"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          return-object
          class="elevation-1"
        >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
          <span v-if="header.key == 'return_sub_request_id'">
            <a href="#" @click.prevent="subRequestDialog(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.return_sub_request_id }}</u></a>
          </span> 
          <span v-else-if="header.key == 'images'">
            <a @click="viewCustomerDeclarationImages(item)" v-if="item.images != ''">
              <span style="text-decoration: underline;color:#1976d2; pointer !important;">View</span>
            </a>
            <span v-else>-</span>            
          </span> 
          <span v-else-if="header.key == 'approval_history'">
            <a @click="viewApprovalHistory(item)" v-if="item.has_approval_history === true">
                <span style="text-decoration: underline;color:#1976d2; pointer !important;">View</span>
            </a>
            <span v-else>N/A</span>              
          </span> 
          <span v-else-if="header.key !== 'images' && item[header.key]">
            <span v-tooltip="item[header.key]">
              {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
            </span>
          </span>
          <span v-else-if="header.key == 'item_location'">
            <span v-if="item.item_location !== null && item.item_location.length <= 30">
              {{ item.item_location }}
            </span>
            <span v-else-if="item.item_location === null">
              N/A
            </span>
            <span v-else>
              <v-tooltip location="top" text="item.item_location">
                <template v-slot:activator="{ props }">
                  <a v-bind="props" style="color: #1976d2;" @click="showFullText(item.item_location)">
                    {{ item.item_location.substring(0, 25) }}...
                  </a>
                </template>
                <span>{{ item.item_location }}</span>
              </v-tooltip>
            </span>
          </span>    
          <span v-else>-</span>
        </template>
        <!-- <template v-for="(header, index) in headers" :key="index" v-slot:[`item.${header.key}`]="{ item }">
          <span v-if="header.key !== 'return_sub_request_id'">
            <span v-if="item[header.key] !== null && item[header.key] !== ''">
              {{ item[header.key] }}
            </span>
            <span v-else>-</span>
          </span>
          <span v-else>
            <a @click="subRequestDialog(item)" style="color: #1976d2; cursor: pointer;">
              <u>{{ item.return_sub_request_id }}</u>
            </a>
          </span>
        </template> -->
        <!-- <template #[`item.item_location`]="{ item }">
          <span v-if="item.item_location !== null && item.item_location.length <= 30">
              {{ item.item_location }}
            </span>
            <span v-else-if="item.item_location === null">
              N/A
            </span>
            <span v-else>
              <v-tooltip location="top" text="item.item_location">
                <template v-slot:activator="{ props }">
                  <a v-bind="props" style="color: #1976d2;" @click="showFullText(item.item_location)">
                    {{ item.item_location.substring(0, 25) }}...
                  </a>
                </template>
                <span>{{ item.item_location }}</span>
              </v-tooltip>
            </span>
        </template> -->
        <!-- <template #[`item.images`]="{ item }">
          <a @click="viewCustomerDeclarationImages(item)" v-if="item.images != ''">
            <span style="text-decoration: underline;color:#1976d2;">View</span>
          </a>
          <span v-else>-</span>
        </template>
        <template #[`item.approval_history`]="{ item }">
          <a @click="viewApprovalHistory(item)" v-if="item.has_approval_history === true">
            <span style="text-decoration: underline;color:#1976d2;">View</span>
          </a>
          <span v-else>N/A</span>
        </template> -->
        <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>

    <!-- pagination display -->
            <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
export default {
  components: {
    HeaderComponent
  },
  data() {
    return {
      headerText: '',
      selected: [],
      filterPopup :false,
      location_search: '',
      branch_search: '',
      return_type_search: '',
      region_search: null,
      search_tag: "",
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      row: "",
      table_data: [],
      isDisabled: true,
      enabled: false,
      filterPopup: false,
      vendor_id: "",
      return_types: [],
      return_type_search: [],
      ra_location_search: "",
      ra_branch_search: "",
      region_search: [],
      search: "",
      alert_message: "",
      alert_type: "info",
      alert: false,
      downloadPopup: false,
      decisionMenu: false,
      approvePopup: false,
      rejectPopup: false,
      regions: "",
      successmessage: "",
      currentUser: {},
      approvalList: [
        { name: "Approve" },
        { name: "Reject" },
        { name: "Not Decided" }
      ],
      loading: false,
      itemss: [
        {
          name: "Approve"
        }
      ],
      dialogVisible: false,
      item_images: [],
      imagePopup: false,
      selectedImage: '',
      approvalHistoryPopup: false,
      approvalHistory: [],
      history_table_data: [],
      Historyheaders: [],
    };
  },

  created() {
    this.loadData();
    this.currentUser = this.$store.state.currentUser;
    this.organization_name = this.$store.state.organization_name;
    if(this.organization_name === 'Voltas'){
     this.headerText = 'Customer Case Approval';
    }else{
     this.headerText = 'Warranty Claim Approval';
    }
  },
  computed:{
    formatted_table_data(){
        return this.table_data.map((item) => {
                const formattedItem = { ...item };
                      this.headers.forEach((header) => {
                        if (header.text.includes("₹")) {
                          formattedItem[header.value] = this.formatCurrency(item[header.value]);
                        }
                      });
                return formattedItem;
        });
      },
  },
  methods: {
    // show Alert messages
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    formatCurrency(value) {
      return Number(value).toLocaleString('en-IN');
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      let hour = date.getHours();
      const minute = date.getMinutes();
      const amPM = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12 || 12;
      const formattedTime = `${hour}:${minute.toString().padStart(2, '0')} ${amPM}`;
      return `${day}/${month}/${year}, ${formattedTime}`;
    },
    loadData(search_action) {
      this.selected = [];
      if (search_action) {
        this.request_type_search = "";
        this.ra_location_search = "";
        this.region_search = "";
        this.ra_branch_search = "";
      }
      this.page = 1;
      this.approvePopup = false;
      this.totalPages = 1;
      this.headers = [
        {title: "Client CRM Ticket No.", sortable: false, key: 'client_crm_ticket_no', minWidth: "200px"},
        { title: "Sub-request ID", align: "start", sortable: false, key: "return_sub_request_id", minWidth: "200px" },
        { title: "BB Ticket No.", key: "bb_ticket_no", minWidth: '200px'},
        { title: "Ageings", key: "ageing", minWidth: "200px" },
        { title: "Customer", key: "customer_name", minWidth: "200px" },
        { title: "Location", key: "item_location", minWidth: "200px" },
        { title: "Branch", key: "branch", minWidth: "200px" },
        { title: "Region", key: "region", minWidth: "200px" },
        { title: "Zone", key: "zone", minWidth: "200px" },
        { title: "Validation", key: "policy", minWidth: "200px" },
        { title: "Repairable", key: "repairable_status", minWidth: "200px" },
        { title: "Repair Cost (₹)", key: "repair_cost", minWidth: "200px" },
        { title: "Repair Cost (%)", key: "repair_cost_percent", minWidth: "200px" },
        { title: "Customer Resolution Decision", key: "customer_resolution_decision", minWidth: "270px" },
        { title: "Images", key: "images", minWidth: "200px"},
        { title: "Approval History", key: "approval_history", minWidth: "200px"},
        { title: "Item Decision", key: "item_decision", minWidth: "200px" }
      ];
      this.fetchTableData();
    },

    // filter Dialog PopUP
    filterListOfButtons(ev) {
      this.search_tag = "";
      this.filterPopup = true;
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40
        ).toString() + "px"
      );
    },

    viewCustomerDeclarationImages(item) {
      this.dialogVisible = true;
      this.item_images = item.images
    },
    openImagePopupSingle(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
    closeDialog(){
      this.dialogVisible = false;
      this.approvalHistoryPopup = false;

    },

    // Apply Filters Function
    applyFilterFunc() {
      const params = new URLSearchParams();
      params.append("return_type", this.request_type_search);
      params.append("return_request_id", this.return_request_id_search);
    },

    // close filter popup and clear all the fields
    closeFilterpopup() {
      this.filterPopup = false;
      this.request_type_search = "";
      this.ra_location_search = "";
      this.region_search = "";
      this.ra_branch_search = "";
    },

    // fetch table data
    fetchTableData() {
      this.loading = true;
      const params = {
        search: this.search_tag,
        location: this.ra_location_search,
        branch: this.ra_branch_search,
        region: this.region_search,
        page: this.page,
        per_page: this.pageSize
      };
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_approvals?return_type=Warranty Claim`, {
          params: params
        })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.return_items;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.filterPopup = false;
            this.loading = false;
            this.closeFilterpopup()
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    searchData() {
      const params = new URLSearchParams();
      params.append("search", this.search_tag);
      params.append("page", this.page);
      params.append("per_page", this.pageSize);
    },
    viewApprovalHistory(item){
      this.loading = true;
      this.Historyheaders = [
        { title: "Date & Time", key: "created_at"},
        { title: "Approver Name & ID", key: "approver_name", sortable: false },
        { title: "Approver Role", key: "approver_role"},
        { title: "Decision", key: "decision" },
        { title: "Remarks", key: "remarks" },
        { title: "Action", key: "status" },
      ];
      this.$httpSecured
      .get(`/api/v1/warehouse/return_initiation/return_approvals/${item.id}/approval_histories`)
      .then(response => {
        if(response.data) {
          this.history_table_data = response.data.data
          this.approvalHistoryPopup = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.showAlert("error", "No Data Found");
        }
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
        this.loading = false;
      });
    },

    subRequestDialog(item) {
      const return_id = item;
      const initialApprovalValues =  item.is_initial_request_approval
        this.$store.commit("setUnique", {
        set_unique: initialApprovalValues
      })
      this.$store.commit("setLotIds", {
        lotIds: return_id,
        action: 'by_link_approve',
        inventoryId: "Warranty Claim Approval"
      });
      this.$router.push({ name: "sub_request_approval" });
    },

    disableActionBtns() {
      if (this.selected.length === 0) {
        return true;
      }

      const firstSelectedType = this.selected[0];

      for (const type of this.selected) {
        if (type !== firstSelectedType) {
          return true;
        }
      }

      return false;
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchTableData();
    },
    handlePageChange(value) {
      this.page = value;
      this.fetchTableData();
    },
    downloadCsv() {
      this.downloadPopup = true;
    },
    approveDialog() {
      this.approvePopup = true;
    },
    rejectDialog() {
      this.rejectPopup = true;
    },
    navigateToFileUpload() {
      this.$store.commit("setLotIds", {
        lotIds: "d2c_return_approval",
        inventoryId: "D2C Return Approval"
      });
      this.$router.push({ name: "LotFileuploadComm" });
    },
    approveDecision(value) {
      this.number++;
      const itemId = this.selected.map(table_data => table_data.id);
      const params = {
        ids: itemId,
        action_type: value,
        is_bulk_approve: true
      };
      if(value === 'Approve'){
        if(this.selected.length > 0){          
          const initialApprovalValues = [...new Set(this.selected.map(item => item.is_initial_request_approval))];
          if(initialApprovalValues.length === 1 && initialApprovalValues[0] === true && this.selected.length > 1){
                this.showAlert("error", "Initailly approver should select single request.");
                return;        
              }
           if (initialApprovalValues.length > 1) {
            this.showAlert("error", "Selected request should be initailly or further level.");
            return;
          }
          this.$store.commit("setUnique", {
            set_unique: initialApprovalValues
          });

         
        }
        this.$store.commit("setLotIds", {
        lotIds: this.selected.length === 1 ? this.selected[0] : itemId,
        action: this.selected.length === 1 ? 'single_item_approve' : 'from_home_approve',
        inventoryId: this.headerText,        
      });
      this.$store.commit("setActiveTab", {
        active_tab: this.selected
      });
      this.$router.push({ name: "sub_request_approval" });
      }else{
        this.$httpSecured
        .post(
          "/api/v1/warehouse/return_initiation/return_approvals/bulk_approve",
          params
        )
        .then(response => {
          if (response.data) {
            this.approvePopup = true;
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.number = 0;
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
        });
      }
    }
  }
};
</script>
<style scoped>
.label-print {
  text-decoration: underline;
  color: #0357d0;
  cursor: pointer;
  box-shadow: none !important;
  padding: 0 !important;
  height: 0 !important;
}
.generate-label {
  color: #19b100;
}
.v-dialog:has(.filter-repair) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}
.img-rad-size {
  width: 186px;
  height: 184px;
  border-radius: 8px;
}
.link-color {
  color: #0357d0;
  font-size: 14px;
  font-weight: 600;
}

.bg-color {
  background: #0357d0;
  color: #ffffff;
}
.v-label {
  position: relative !important;
  margin-top: 50px !important;
}

.disable-text-color {
  color: #9f9d9d;
}
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 262px) !important;
}
.v-data-table.approval-history {
  height: calc(var(--vh, 1vh) * 100 - 690px) !important;
}
.custom-control_outlined button {
      min-height: 52px;
      border-width: 1px;
      border-radius: 4px;
      border-color: rgba(0,0,0,.42);
      border-style: solid;
    }
.filter_ui{
  margin-left: 28px !important;
  margin-top: 12px !important;
}
</style>
